module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-digestion.b1909507.svg";